/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Order } from './Order';
import {
    OrderFromJSON,
    OrderFromJSONTyped,
    OrderToJSON,
    OrderToJSONTyped,
} from './Order';
import type { Organization } from './Organization';
import {
    OrganizationFromJSON,
    OrganizationFromJSONTyped,
    OrganizationToJSON,
    OrganizationToJSONTyped,
} from './Organization';

/**
 * 
 * @export
 * @interface BusinessUnit
 */
export interface BusinessUnit {
    /**
     * 
     * @type {string}
     * @memberof BusinessUnit
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BusinessUnit
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof BusinessUnit
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BusinessUnit
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof BusinessUnit
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessUnit
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessUnit
     */
    fullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessUnit
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BusinessUnit
     */
    organizationId?: string;
    /**
     * 
     * @type {Organization}
     * @memberof BusinessUnit
     */
    organization?: Organization;
    /**
     * 
     * @type {string}
     * @memberof BusinessUnit
     */
    parentId?: string | null;
    /**
     * 
     * @type {BusinessUnit}
     * @memberof BusinessUnit
     */
    parent?: BusinessUnit;
    /**
     * 
     * @type {Array<BusinessUnit>}
     * @memberof BusinessUnit
     */
    children?: Array<BusinessUnit> | null;
    /**
     * 
     * @type {Array<Order>}
     * @memberof BusinessUnit
     */
    orders?: Array<Order> | null;
}

/**
 * Check if a given object implements the BusinessUnit interface.
 */
export function instanceOfBusinessUnit(value: object): value is BusinessUnit {
    return true;
}

export function BusinessUnitFromJSON(json: any): BusinessUnit {
    return BusinessUnitFromJSONTyped(json, false);
}

export function BusinessUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessUnit {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
        'description': json['description'] == null ? undefined : json['description'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'organization': json['organization'] == null ? undefined : OrganizationFromJSON(json['organization']),
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'parent': json['parent'] == null ? undefined : BusinessUnitFromJSON(json['parent']),
        'children': json['children'] == null ? undefined : ((json['children'] as Array<any>).map(BusinessUnitFromJSON)),
        'orders': json['orders'] == null ? undefined : ((json['orders'] as Array<any>).map(OrderFromJSON)),
    };
}

export function BusinessUnitToJSON(json: any): BusinessUnit {
    return BusinessUnitToJSONTyped(json, false);
}

export function BusinessUnitToJSONTyped(value?: BusinessUnit | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'isActive': value['isActive'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'code': value['code'],
        'name': value['name'],
        'fullName': value['fullName'],
        'description': value['description'],
        'organizationId': value['organizationId'],
        'organization': OrganizationToJSON(value['organization']),
        'parentId': value['parentId'],
        'parent': BusinessUnitToJSON(value['parent']),
        'children': value['children'] == null ? undefined : ((value['children'] as Array<any>).map(BusinessUnitToJSON)),
        'orders': value['orders'] == null ? undefined : ((value['orders'] as Array<any>).map(OrderToJSON)),
    };
}

